import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d2bb7d0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=4d2bb7d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2bb7d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2bb7d0')) {
      api.createRecord('4d2bb7d0', component.options)
    } else {
      api.reload('4d2bb7d0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4d2bb7d0&scoped=true&", function () {
      api.rerender('4d2bb7d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/reports/documents/components/filters/index.vue"
export default component.exports